export default "__VITE_ASSET__BdNhJP4v__"